import IMask from 'imask/esm/imask';
import page from '../helpers/page';
import 'imask/esm/masked/number';
import axios from 'axios';


function deleteGood(e, state) {
	if (state.value === 0) {
		return;
	}
	const element = e.target;
	const itemId = element.dataset.id;
	let good = element.parentElement;

	while (!good.classList.contains('basket__goods-item')) {
		good = good.parentElement;
	}

	axios({
		method: 'get',
		url: '/basket?delete=' + itemId,
	})
		.then((response) => {
			const data = response.data;

			const responseDocument = new DOMParser().parseFromString(data, "text/html");
			const responseBasketData = responseDocument.querySelector(".basket__goods");
			const price = document.querySelector(".basket__result-price");
			const responsePrice = responseDocument.querySelector(".basket__result-price");

			if (!responseBasketData) {
				const responsePageContainer = responseDocument.querySelector(".basket-page__container");
				const pageContainer = document.querySelector(".basket-page__container");
				pageContainer.replaceWith(responsePageContainer);
			} else {
				good.remove();
				price.replaceWith(responsePrice);
			}
		})
		.catch((error) => {
			console.log('Error ' + error.message)
		});
}

function changeQty(good, currentCount, count) {
	let parameters = new URLSearchParams();
	const itemId = good.querySelector('.basket__delete-link').dataset.id;

	parameters.append('id', itemId);
	parameters.append('col', count);
	axios({
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		url: '/basket/changecol',
		data: parameters
	}).then((data) =>
	{
		if (data.error)
			alert(data.message);
		else
		{
			const goodPriceElement = good.querySelector('.basket__goods-item-price span');
			const goodBonusElement = good.querySelector('.basket__goods-item-bonus span');
			const goodCurrentSum = parseInt(goodPriceElement.textContent);
			const goodPrice = goodCurrentSum / currentCount;
			const goodNewSum = goodPrice * count;
			let bonusSum = goodNewSum * 0.03;

			bonusSum = Number.isInteger(bonusSum) ? bonusSum : bonusSum.toFixed(1);

			goodPriceElement.textContent = goodNewSum + ' ₽';
			goodBonusElement.textContent = bonusSum + ' ₽';
		}
	})
	.catch((error) => {
		console.log('Error ' + error.message)
	});
}

function changeSum() {
	axios({
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		url: '/basket/getsum',
	}).then((data) =>
	{
		if (data.error)
			alert(data.message);
		else
		{
			const sumElement = document.querySelector(".basket__result-price");
			const bonusElement = document.querySelector(".basket__result-bonus");
			const newSum = data.data.sum;
			const newBonusSum = data.data.bonusNum;

			sumElement.textContent = newSum;
			bonusElement.textContent = newBonusSum;
		}
	})
	.catch((error) => {
		console.log('Error ' + error.message)
	});
}

function changeItemsInBasketQty() {
	axios({
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		url: '/basket/getstat',
	}).then((data) =>
	{
		if (data.error)
			alert(data.message);
		else
		{
			const itemsInCartElement = document.querySelector(".header-center__right-amount");
			const goodsQty = data.data.count;

			itemsInCartElement.textContent = goodsQty;
		}
	})
	.catch((error) => {
		console.log('Error ' + error.message)
	});
}


page(() => {
	const items = document.querySelectorAll('.basket__goods-item');
	items.forEach((item) => {

		const itemQty = item.querySelector(".amount-input").value;

		const state = {
			value: itemQty,
		};

		const valueInput = item.querySelector('.amount-input');
		const addBtn = item.querySelector('.amount-input__btn-add');
		const removeBtn = item.querySelector('.amount-input__btn-remove');
		const deleteGoodBtn = item.querySelector('.basket__delete-link');
		const mobileDeleteGoodBtn = item.querySelector('.basket__delete-btn');

		addBtn.addEventListener('click', (e) => {
			e.preventDefault();
			let currentValue = parseInt(state.value);
			state.value = currentValue + 1;
			valueInput.value = state.value;
			changeQty(item, currentValue, state.value);
			changeSum();
		});

		removeBtn.addEventListener('click', (e) => {
			e.preventDefault();
			let currentValue = parseInt(state.value);
			if (currentValue === 1) {
				return;
			}
			state.value = currentValue - 1;
			valueInput.value = state.value;
			changeQty(item, currentValue, state.value);
			changeSum();
		});

		deleteGoodBtn.addEventListener('click', (e) => {
			e.preventDefault();
			deleteGood(e, state);
			changeItemsInBasketQty();
		});

		mobileDeleteGoodBtn.addEventListener('click', (e) => {
			e.preventDefault();
			deleteGood(e, state);
			changeItemsInBasketQty();
		});

		valueInput.addEventListener('input', (ev) => {
			const targetValue = parseInt(ev.target.value, 10);

			if (isNaN(targetValue) || targetValue < 1) {
				return;
			}

			const currentQty = state.value;
			state.value = targetValue;

			changeQty(item, currentQty, state.value);
			changeSum();
		});
	});

	let phoneMask = IMask(document.getElementById('basket-phone'), {
		mask: '+{7}(000)000-00-00',
	});
});
